export enum InputType {
  text = 'text',
  textarea = 'textarea', // TODO make it working for mobile
  password = 'password',
  email = 'email',
}
